// 订单商品标签模板设置

import httpClient from "@/services/http/mainServerClient";

import OrderItemLabelTemplateDTO from "@/dto/template/OrderItemLabelTemplateDTO";

// 获取当前店铺的订单商品标签模板
function getTemplates(): Promise<OrderItemLabelTemplateDTO[]> {
    return httpClient.get(`/orderItemLabelTemplate`);
}

interface CreateTemplateParams {
    /**模板名称 */
    name: string;
    width: number;
    height: number;
    picture?: Blob;
}

// 新增订单商品标签模板
function createTemplate(params: CreateTemplateParams) {
    const formData = new FormData();

    Object.entries(params).forEach(([key, value]) => {
        if (value) {
            formData.append(key, value);
        }
    });

    return httpClient.post(`/orderItemLabelTemplate`, formData, { timeout: 60000 });
}

interface CreateTemplateByQnParams {
    name: string;
    width: number;
    height: number;
    pictureFileSize?: number;
    pictureOriginalName?: string;
    pictureUrl?: string;
}

function createTemplateByQn(params: CreateTemplateByQnParams) {
    return httpClient.post("/orderItemLabelTemplate/qianniu/orderItemLabelTemplate", params);
}

// 修改订单商品标签模板
function updateTemplate(id: any, params: any) {
    return httpClient.post(`/orderItemLabelTemplate/update/${id}`, params);
}

// 删除订单商品标签模板
function deleteTemplate(id: any) {
    return httpClient.post(`/orderItemLabelTemplate/delete/${id}`);
}

// 绑定打印机
function bindPrinter({ templateId, printer }: any) {
    return httpClient.post(`/orderItemLabelTemplate/${templateId}:bindPrinter`, {
        printer,
    });
}

// 解绑打印机
function unbindPrinter(templateId: any) {
    return httpClient.post(`/orderItemLabelTemplate/${templateId}:unbindPrinter`);
}

// 绑定店铺
function bindShop({ templateId, shopIds }: any) {
    return httpClient.post(`/orderItemLabelTemplate/${templateId}:bindShop`, {
        shopIds,
    });
}

// 解绑店铺
function unbindShop(templateId: any) {
    return httpClient.post(`/orderItemLabelTemplate/${templateId}:unbindShop`);
}

// 复制当前模板
function copyTemplate(templateId: any) {
    return httpClient.post(`/orderItemLabelTemplate/${templateId}:copy`);
}

// 复制系统模板
function copySystemTemplate(templateId: any) {
    return httpClient.post(`/orderItemLabelTemplate/${templateId}:copySystem`);
}

// 获取系统模板
function getSystemTemplates(): Promise<OrderItemLabelTemplateDTO[]> {
    return httpClient.get(`/orderItemLabelTemplate/system`);
}

export function recoveryOrderItemLabelTemplate(id: number) {
    return httpClient.post(`/orderItemLabelTemplate/recovery/${id}`);
}

export default {
    getTemplates,
    getSystemTemplates,
    createTemplate,
    createTemplateByQn,
    updateTemplate,
    deleteTemplate,
    bindPrinter,
    unbindPrinter,
    bindShop,
    unbindShop,
    copyTemplate,
    copySystemTemplate,
};
